// src/App.jsx
import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Container,
  Grid,
  TextField,
  Card,
  CardContent,
  Typography,
  Button,
  CircularProgress,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";

const App = () => {
  const [wallets, setWallets] = useState([]);
  const [loading, setLoading] = useState(false);
  const [approvals, setApprovals] = useState([]);
  const [newWallet, setNewWallet] = useState("");

  // Fetch wallets from the database on load
  useEffect(() => {
    const fetchWallets = async () => {
      setLoading(true);
      try {
        const response = await axios.get("/wallets/list");
        setWallets(response.data);
      } catch (error) {
        console.error("Failed to fetch wallets:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchWallets();
  }, []);

  // Fetch token approvals for a wallet
  const fetchApprovals = async (walletAddress) => {
    setLoading(true);
    try {
      const response = await axios.get(`/wallets/approvals/${walletAddress}`);
      setApprovals(response.data);
    } catch (error) {
      console.error("Failed to fetch approvals:", error);
    } finally {
      setLoading(false);
    }
  };

  // Add a new wallet to the database
  const addWallet = async () => {
    if (!newWallet) return;
    setLoading(true);
    try {
      await axios.post("/wallets/add", { address: newWallet });
      setWallets([...wallets, { address: newWallet, date: new Date().toISOString() }]);
      setNewWallet("");
    } catch (error) {
      console.error("Failed to add wallet:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container style={{ marginTop: "50px" }}>
      <Typography variant="h3" align="center" gutterBottom>
        Web3 Wallet Dashboard
      </Typography>

      {/* Add Wallet Section */}
      <Grid container spacing={2} alignItems="center" style={{ marginBottom: "20px" }}>
        <Grid item xs={8}>
          <TextField
            label="Add New Wallet Address"
            variant="outlined"
            fullWidth
            value={newWallet}
            onChange={(e) => setNewWallet(e.target.value)}
          />
        </Grid>
        <Grid item xs={4}>
          <Button variant="contained" color="primary" fullWidth onClick={addWallet}>
            Add Wallet
          </Button>
        </Grid>
      </Grid>

      {/* Wallet Table */}
      <Typography variant="h5" gutterBottom>
        Wallet List
      </Typography>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell><strong>Address</strong></TableCell>
            <TableCell><strong>Date Added</strong></TableCell>
            <TableCell><strong>Approvals</strong></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {wallets.map((wallet) => (
            <TableRow key={wallet.address}>
              <TableCell>{wallet.address}</TableCell>
              <TableCell>{new Date(wallet.date).toLocaleDateString()}</TableCell>
              <TableCell>
                <Button variant="outlined" onClick={() => fetchApprovals(wallet.address)}>
                  Check Approvals
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      {/* Approval Details */}
      {approvals.length > 0 && (
        <>
          <Typography variant="h5" gutterBottom style={{ marginTop: "30px" }}>
            Token Approvals
          </Typography>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell><strong>Network</strong></TableCell>
                <TableCell><strong>Approved Amount</strong></TableCell>
                <TableCell><strong>Token Address</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {approvals.map((approval) => (
                <TableRow key={approval.network}>
                  <TableCell>{approval.network}</TableCell>
                  <TableCell>{approval.approvedAmount}</TableCell>
                  <TableCell>{approval.token}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </>
      )}
    </Container>
  );
};

export default App;
